define('bizzabo/views/ModelBindingMixin',['jquery', 'underscore'], function($, _) {

    var ModelBindingMixin = {

        /* Members which are used by this class:
         modelBindingWhiteList : [],
         modelBindingBlackList : [],
         bindAllValidationFields : false,
         */
        actualModelBindingFields : [],

        initModelBinding : function() {
            _.bindAll(this, 'formChanged');
            this.events = this.events || {};
            this.actualModelBindingFields = this.modelBindingWhiteList ? this.modelBindingWhiteList : [];
            if (this.bindAllValidationFields || this.actualModelBindingFields.length === 0) {
                this.actualModelBindingFields = _.union(this.actualModelBindingFields, _.keys(this.model.validation));
            }
            if (this.modelBindingBlackList && this.modelBindingBlackList.length) {
                this.actualModelBindingFields = _.difference(this.actualModelBindingFields, this.modelBindingBlackList);
            }

            for (var i = 0; i < this.actualModelBindingFields.length; i++) {
                var attr = this.actualModelBindingFields[i],
                    formChangedFunctionName = ("form-" + attr + "-changed").toCamel(),
                    modelChangedFunctionName = ("model-" + attr + "-changed").toCamel();

                // bind form changes to model
                this.events['change [name="' + attr + '"]'] = _.has(this, formChangedFunctionName) ? formChangedFunctionName : "formChanged";

                // bind model changes to model
                if (!_.has(this, modelChangedFunctionName)) {
                    this[modelChangedFunctionName] = function(attr) {
                        return function() { // closure to fixate the attr variable
                            this.$('[name="' + attr + '"]').val(this.model.get(attr));
                        }
                    }(attr);
                }
                this.model.on('change:' + attr, this[modelChangedFunctionName], this);
            }
        },

        removeModelBinding : function() {
            for (var i = 0; i < this.actualModelBindingFields.length; i++) {
                var attr = this.actualModelBindingFields[i],
                    modelChangedFunctionName = ("model-" + attr + "-changed").toCamel();
                if (_.has(this, modelChangedFunctionName)) {
                    this.model.off('change:' + attr, this[modelChangedFunctionName], this);
                }
            }
        },

        formChanged : function(eventObject) {
            var ev = eventObject || event;
            var attr = ev.currentTarget.name;
            var value = $(ev.currentTarget).val();
            this.model.set(attr, value, {
                validate : false
            });
        }
    };

    return ModelBindingMixin;

});
